import * as types from '../event_types'
import * as restlet from '../actions/rest'
import Vue from 'vue';
import Cookies from 'js-cookie';
// STATE

const state = {
  user: {},
  loading: true
}

// GETTERS

const getters = {
  user: s => s.user,
  loading: s => s.loading
}

// ACTIONS

const actions = {
  signOut(){
    Cookies.remove('user')
    window.location = process.env.VUE_APP_LOGOUT_URI
  },
  fetchUser({ commit }){
    let user = Cookies.get('user')
    if (user) {
      commit(types.SET_USER, JSON.parse(user))
    }else if (Cookies.get('token')){
      restlet.getLoggedInUser().then(function(response){
        if(response.status === 200) {
          var in30Minutes = 1/48;
          Cookies.set('user', JSON.stringify(response.data.data), {
            expires: in30Minutes
          });
          commit(types.SET_USER, response.data.data)
        }
      })
    }else{
      let current = window.location
      window.location = process.env.VUE_APP_LOGIN_URI + "?state=" + current
 
    }
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setUser(s, user){
    console.log("setting user")
    Vue.set(s, 'loading', false)
    Vue.set(s, 'user', user)
  }
}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
